import React from "react";
import { LandingLanguageProvider } from "../../../contexts/landing-language";
import Header from "./Header";
import Hero from "./Hero";
import BookingWidget from "./BookingWidget";
import About from "./About";
import Facilities from "./Facilities";
import Rooms from "./Rooms";
import Gallery from "./Gallery";
import Footer from "./Footer";
import GuestWidget from "./GuestWidget";

const UnnamedComponent = () => {
  return (
    <LandingLanguageProvider>
      {/* The head is server-rendered from Hebe::SeoPresenter via
          shared/_page_seo. It used to live here as an Inertia <Head>, which
          browsers honour and non-JS consumers — Bing, AI crawlers, WhatsApp and
          Facebook link unfurlers — never see. Re-adding it here would not
          replace the server tags but sit alongside them: Inertia's head manager
          only removes elements it tagged with data-inertia. */}
      <React.Fragment>
        <Header />
        <Hero />
        <BookingWidget />
        <About />
        <Facilities />
        <Rooms />
        <Gallery />
        <Footer />
        <GuestWidget />
      </React.Fragment>
    </LandingLanguageProvider>
  );
};

export default UnnamedComponent;
